export const environment = {
  production: false,
  apiUrl: 'https://dev.api.idra.idlys.fr/api/v1',
  sanctumCsrfUrl: 'https://dev.api.idra.idlys.fr/sanctum/csrf-cookie',
};
